import React, { useEffect, useState } from "react";
import {
  I2cInput,
  I2cRadio,
  I2cRadioGroup,
  I2cPhoneField,
  I2cListItem,
  I2cCheckboxGroup,
  I2cCheckbox,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import OtherServices from "./OtherServices";
import { emailAdressValidator } from "../../../Utils/stringUtls";
export const programMngt = [
  { label: "Managed by i2c inc.", value: 0 },
  { label: "Managed by Sponsor Bank/Issuer/ISO", value: 1 },
  { label: "Other", value: 2 },
];
export const otherServices = [
  { label: "Mobile Text Messaging (short code required)", value: 0 },
  { label: "Bill Payment", value: 1 },
  { label: "Communication Manager", value: 2 },
  { label: "Transaction (service) Coupons", value: 3 },
  { label: "Rewards", value: 4 },
  { label: "i-Coupons", value: 5 },
  { label: "Other", value: 6 },
];
const ProgramManagementServices = ({
  type,
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const [selectedOtherServices, setSelectedOtherServices] = useState([]);
  const [selectedServicesValues, setServicesCheckboxValues] = useState({
    asObject: "Null",
  });

  const handleOtherServicesChange = (event) => {
    let selectedComValues;
    if (isNaN(event)) selectedComValues = event.target.value;
    else selectedComValues = event;
    const preSelected = methods.getValues("of_pms_other_services") ?? [];
    // let updatedComPrepaid = [...preSelected];
    let updatedComPrepaid = [
      ...(methods.getValues("of_pms_other_services") ?? []),
    ];
    if (updatedComPrepaid.includes(selectedComValues)) {
      updatedComPrepaid = updatedComPrepaid.filter(
        (card) => card !== selectedComValues,
      );
    } else {
      updatedComPrepaid.push(selectedComValues);
    }
    if (
      !updatedComPrepaid.includes(6) &&
      methods.watch("of_pms_other_services_other").length
    ) {
      methods.setValue("of_pms_other_services_other", "");
    }
    methods.setValue("of_pms_other_services", updatedComPrepaid);
  };
  const generalErrorMessage = "Field is required";
  const validationSchema = Yup.object({
    of_pms_processor: Yup.number().required(generalErrorMessage).nonNullable(),
    of_pms_company_name: Yup.string().when("of_pms_processor", {
      is: (service_type) => service_type === 2,
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_pms_contact_name: Yup.string().when("of_pms_processor", {
      is: (service_type) => service_type === 2,
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_pms_job_title: Yup.string().when("of_pms_processor", {
      is: (service_type) => service_type === 2,
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_pms_phone_number: Yup.string().when("of_pms_processor", {
      is: (service_type) => service_type === 2,
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_pms_email: Yup.string().when("of_pms_processor", {
      is: (service_type) => service_type === 2,
      then: () =>
        Yup.string()
          .required(generalErrorMessage)
          .min(1, generalErrorMessage)
          .test("", "", function (item) {
            // this.parent gives the whole parent
            return emailAdressValidator(item);
          }),
      otherwise: () => Yup.string().optional(),
    }),
    of_pms_other_services: Yup.array().optional(),
    of_pms_other_services_other: Yup.string().when("of_pms_other_services", {
      is: (of_pms_other_services) => of_pms_other_services.includes(6),
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_pms_other_vendors: Yup.string().optional(),
  });

  const handleOtherServices = (event) => {
    const selectedServicesType = event.target?.inputValue || [];
    setSelectedOtherServices(selectedServicesType);
    setServicesCheckboxValues({
      asObject: JSON.stringify({ digits: selectedServicesType }),
    });
  };
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      of_pms_processor: "",
      of_pms_company_name: "",
      of_pms_contact_name: "",
      of_pms_job_title: "",
      of_pms_phone_number: "",
      of_pms_country: "",
      of_pms_email: "",
      of_pms_other_services: [],
      of_pms_other_services_other: "",
      of_pms_other_vendors: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "of_pms_processor",
    "of_pms_company_name",
    "of_pms_contact_name",
    "of_pms_job_title",
    "of_pms_phone_number",
    "of_pms_country",
    "of_pms_email",
    "of_pms_other_services",
    "of_pms_other_services_other",
    "of_pms_other_vendors",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[6]["6_2"][field] ?? "");
      });
      /*  methods.setValue("of_pms_other_services", []); */
      methods.trigger();
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      6: {
        ...addFormData["6"],
        "6_2": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("6_2", true);
    else setFormValidStates("6_2", false);
    handleValueChanges();
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="of_pms_processor"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("of_pms_processor")}
                    {...field}
                    name="of_pms_processor"
                    onI2cChange={(e) => {
                      [
                        "of_pms_company_name",
                        "of_pms_contact_name",
                        "of_pms_job_title",
                        "of_pms_phone_number",
                        "of_pms_country",
                        "of_pms_email",
                      ].map((field) => methods.setValue(field, ""));
                      field.onChange(e);
                      methods.trigger();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {programMngt.map((radio, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="4@md"
                          variant="receipt"
                          label={radio.label}
                          checked={
                            methods.watch("of_pms_processor") === radio.value
                          }
                          sublabel=""
                          value=""
                          type="checkbox"
                        >
                          <I2cRadio
                            checked={
                              methods.watch("of_pms_processor") === radio.value
                            }
                            slot="prefix"
                            filled
                            name="of_pms"
                            value={radio.value}
                          >
                            {" "}
                          </I2cRadio>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("of_pms_processor") === 2 && (
            <div i2c-grid="12">
              <div className="custom-label-light mb-12">
                If using a 3rd Party Vendor, please provide details:
              </div>
              <div i2c-grid="grid gap-column-sm gap-row-md">
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_pms_company_name"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          required
                          label="Company Name"
                          placeholder="Enter Company Name"
                          name={"of_pms_company_name"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_pms_company_name &&
                        methods.formState.touchedFields.of_pms_company_name
                          ? true
                          : false
                      }
                      message={
                        errors.of_pms_company_name?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_pms_contact_name"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          required
                          label="Contact Name"
                          placeholder="Enter Contact Name"
                          name={"of_pms_contact_name"}
                        />
                      )}
                    />
                    <ErrorMessage
                      show={
                        errors.of_pms_contact_name &&
                        methods.formState.touchedFields.of_pms_contact_name
                          ? true
                          : false
                      }
                      message={
                        errors.of_pms_contact_name?.message ?? "Invalid input"
                      }
                    />
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_pms_job_title"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          label="Job Title"
                          required
                          placeholder="Enter Job Title"
                          name={"of_pms_job_title"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_pms_job_title &&
                        methods.formState.touchedFields.of_pms_job_title
                          ? true
                          : false
                      }
                      message={
                        errors.of_pms_job_title?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <I2cPhoneField
                      format="INTERNATIONAL"
                      label="Company Phone "
                      tooltip-help="Custom Text"
                      name="ci_companyName"
                      size="large"
                      country-box
                      selectedCountry={methods.watch("of_pms_country") || "US"}
                      value={methods.watch("of_pms_phone_number")}
                      errorMessageVisible={false}
                      required
                      onI2cChange={(e) => {
                        const country = e.target.country;
                        const isValid = e.target.isValid;
                        const value = e.target.value;
                        methods.setValue("of_pms_country", country);
                        methods.setValue("of_pms_phone_number", value);
                        handleValueChanges();
                        if (!isValid) {
                          methods.setError("of_pms_phone_number", {
                            message: e.target.guide,
                          });
                        } else {
                          methods.clearErrors("of_pms_phone_number");
                        }
                      }}
                    />
                    {/* <ErrorMessage
												show={
													errors.of_pms_phone_number &&
													methods.formState.touchedFields.of_pms_phone_number
														? true
														: false
												}
												message={
													errors.of_pms_phone_number?.message ?? "Invalid input"
												}
											/> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_pms_email"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          type="email"
                          size="large"
                          label="Email"
                          required
                          placeholder="Enter Email"
                          name={"of_pms_email"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_pms_email &&
                        methods.formState.touchedFields.of_pms_email
                          ? true
                          : false
                      }
                      message={errors.of_pms_email?.message ?? "Invalid input"}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">Other Services</div>
            <div className="custom-label-light mb-16">
              (Additional setup and monthly minimum may apply)
            </div>
            <Controller
              name="of_pms_other_services"
              control={control}
              render={({ field }) => (
                <>
                  <I2cCheckboxGroup {...field}>
                    <div i2c-grid="grid gap-sm">
                      {otherServices.map((service, index) => (
                        <I2cListItem
                          key={index}
                          variant="receipt"
                          label={service.label}
                          sublabel=""
                          i2c-grid="4@md"
                          value=""
                          type="checkbox"
                          checked={methods
                            .watch("of_pms_other_services")
                            .includes(service.value)}
                          onI2cCheckboxClicked={(e) => {
                            handleOtherServicesChange(service.value);
                            handleValueChanges();
                            methods.trigger();
                          }}
                        >
                          <I2cCheckbox
                            slot="prefix"
                            // name="op_otherServices"
                            value={service.value}
                            label=""
                            ignoreTab
                            filled
                            className="customCheckbox"
                            checked={methods
                              .watch("of_pms_other_services")
                              ?.includes(service.value)}
                           
                          ></I2cCheckbox>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cCheckboxGroup>
                </>
              )}
            />
          </div>
          {methods.watch("of_pms_other_services").includes(6) && (
            <div i2c-grid="6@md">
              <div className="single-field-wrapper">
                <Controller
                  name="of_pms_other_services_other"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      type="text"
                      size="large"
                      required
                      label="Please Specify"
                      placeholder="Enter Details"
                      name={"of_pms_other_services_other"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.of_pms_other_services_other &&
                    methods.formState.touchedFields.of_pms_other_services_other
                      ? true
                      : false
                  }
                  message={
                    errors.of_pms_other_services_other?.message ??
                    "Invalid input"
                  }
                /> */}
              </div>
            </div>
          )}
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">
              Other Networks/Vendor Integrations
            </div>
            <div className="custom-label-light mb-16">
              Any other 3rd party not mentioned in the list.
            </div>
            <div i2c-grid="grid 6@md">
              <div className="single-field-wrapper">
                <Controller
                  name="of_pms_other_vendors"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      type="text"
                      size="large"
                      placeholder="Enter Details"
                      name={"of_pms_other_vendors"}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.of_pms_other_vendors &&
                    methods.formState.touchedFields.of_pms_other_vendors
                      ? true
                      : false
                  }
                  message={
                    errors.of_pms_other_vendors?.message ?? "Invalid input"
                  }
                />
              </div>
              {type === "credit" && (
                <>
                  <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                      <div className="sub-heading mb-4">Other Services</div>
                      <div className="custom-label-light mb-16">
                        (Additional setup and monthly minimum may apply)
                      </div>
                      <I2cCheckboxGroup
                        onI2cChange={(e) => handleOtherServices(e)}
                      >
                        <div i2c-grid="grid gap-sm">
                          {otherServices.map((service, index) => (
                            <div key={index} i2c-grid="4@md">
                              <I2cListItem
                                variant="receipt"
                                label={service}
                                sublabel=""
                                value=""
                                type="checkbox"
                              >
                                <I2cCheckbox
                                  slot="prefix"
                                  name="op_otherServices"
                                  value={service}
                                  label=""
                                  ignoreTab
                                  filled
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            </div>
                          ))}
                        </div>
                      </I2cCheckboxGroup>
                      {selectedOtherServices.map((selectedCard, index) => (
                        <>
                          {selectedCard === "Other" && (
                            <div
                              key={index}
                              i2c-grid="grid 6@md"
                              className="mt-16"
                            >
                              <I2cInput
                                name="of_otherServices_Other"
                                label="Please Specify"
                                size="large"
                                required
                              ></I2cInput>
                            </div>
                          )}
                        </>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProgramManagementServices;
